import { PageBlocks } from 'src/components/PageBlocks';
import { EventType } from 'src/types/backendContent';

type EventContentProps = Pick<EventType, 'content'>;

export function EventContent({ content }: EventContentProps) {
  if (!content?.blocks?.length) {
    return null;
  }

  return <PageBlocks blocks={content.blocks} />;
}
